import { computed, ref } from "vue";
import { defineStore } from "pinia";
import type { UserProfile } from "@api-gen/identity_pb";
import { api, SESSION_MARKER_KEY } from "@/api";

export const useAuthStore = defineStore("auth", () => {
  const profile = ref<UserProfile>();
  const initialized = ref(false);
  const sessionPresent = ref(Boolean(localStorage.getItem(SESSION_MARKER_KEY)));
  const isAuthenticated = computed(() => sessionPresent.value);

  async function initialize() {
    if (initialized.value) return;
    initialized.value = true;
    if (!isAuthenticated.value) return;
    try {
      profile.value = (await api.identity.getProfile({})).profile;
    } catch {
      clear();
    }
  }

  function setSession(user: UserProfile) {
    localStorage.setItem(SESSION_MARKER_KEY, "1");
    sessionPresent.value = true;
    profile.value = user;
  }

  function clear() {
    localStorage.removeItem(SESSION_MARKER_KEY);
    sessionPresent.value = false;
    profile.value = undefined;
  }

  async function logout() {
    try {
      await api.identity.logout({ allDevices: false });
    } finally {
      clear();
    }
  }

  return {
    profile,
    initialized,
    isAuthenticated,
    initialize,
    setSession,
    logout,
    clear,
  };
});
